var React = require('react');

function HayfieldWordmarkReverse (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.4 0v24.8H42V0h11.4v59H42V34.1H11.4V59H0V0h11.4zm93.5 0L131 59h-12l-6.1-14.3H86.6L80.8 59H68.9L93.2 0h11.7zM90 36h19.1l-10-23.3L90 36zm58.2-36l14.3 19.7L176.9 0h13.6l-22.3 29.8V59h-11.4V29.7L134.3 0h13.9zm93.6 0v8.9h-24.5v15.3h24.5v9h-24.5V59h-11.4V0h35.9zm30.7 0v59h-11.4V0h11.4zm59.9 0v8.9h-26.7v15.5h25.6v8.9h-25.6v16.8H333V59h-38.7V0h38.1zm31.3 0v50.1h28.6V59h-40V0h11.4zm69.7 0c5.7-.1 11.3 1.2 16.4 3.8 4.7 2.4 8.5 6 11.2 10.5a29.18 29.18 0 0 1 4 15.3 29.18 29.18 0 0 1-4 15.3c-2.7 4.5-6.6 8.1-11.3 10.4-5.3 2.5-11 3.8-16.9 3.7h-24V0h24.6zm-1.2 50.1c6.3 0 11.4-1.9 15.2-5.7s5.7-8.7 5.7-14.9c0-6.4-1.9-11.4-5.8-15.1s-9-5.5-15.5-5.5h-11.7v41.2h12.1z"}));
}

HayfieldWordmarkReverse.defaultProps = {"viewBox":"0 0 465 59","fill":"#fff"};

module.exports = HayfieldWordmarkReverse;

HayfieldWordmarkReverse.default = HayfieldWordmarkReverse;
